import { useNavigate } from 'react-router-dom';

import i18n from 'i18next';
import { LANGUAGES } from 'assets/constants';

const normalizeLang = (value) => {
  const lang = (value || "").toLowerCase().split("-")[0];
  return LANGUAGES.includes(lang) ? lang : "sp";
};

function useLocalizedNavigate(state) {

  const navigate = useNavigate();

  const langParam = `/${normalizeLang(i18n.language)}`;

  const localizedNavigate = (path,state) => {

    if(state?.state?.lang)
    {
        navigate(`/${normalizeLang(state?.state?.lang)}`);
    }
    else{
        navigate(`${langParam}${path}`,state);     
    }
  };

  return localizedNavigate;
}

export default useLocalizedNavigate;
